// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner__2o-81","errorLogs":"EditorFooter_errorLogs__9Unvp"};